import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { CropTypeNode } from '../../services/cropTypeService';
import MultiSelectCombo from './MultiSelectCombo';

interface Props {
  options: CropTypeNode[];
  value: string[];
  onChange: (codes: string[]) => void;
}

function depthOf(node: CropTypeNode, byCode: Map<string, CropTypeNode>): number {
  let d = 0;
  let cur = node.parentCode;
  const seen = new Set<string>();
  while (cur && byCode.has(cur) && !seen.has(cur)) { seen.add(cur); d++; cur = byCode.get(cur)!.parentCode; }
  return d;
}

const CropMultiSelect: React.FC<Props> = ({ options, value, onChange }) => {
  const { t } = useTranslation();
  const items = useMemo(() => {
    const byCode = new Map(options.map(o => [o.code, o]));
    return options.map(c => ({ code: c.code, label: c.name, depth: depthOf(c, byCode) }));
  }, [options]);
  return (
    <MultiSelectCombo
      items={items}
      value={value}
      onChange={onChange}
      ariaLabel={t('common.multiselect.selectCrops', { defaultValue: 'Select crops' })}
    />
  );
};

export default CropMultiSelect;
